export default __webpack_public_path__ + "static/media/smile-emoji.798561a0.svg";